import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyDLzDneEnX_EkNQx3Jeajpd7XIB8JRcppE",
  authDomain: "app-738f0.firebaseapp.com",
  projectId: "app-738f0",
  storageBucket: "app-738f0.appspot.com",
  messagingSenderId: "678647120143",
  appId: "1:678647120143:web:4eb7d620c9e08ff505fe7a",
  measurementId: "G-KW2CVSBJVJ",
};

initializeApp(firebaseConfig);